export default {
  title: "PDF-Validierung",
  page: "Seite",
  pages: "Seiten",
  checkingFirstPageContent: "Überprüfen des Inhalts der ersten Seite...",
  analyzingPdfContent: "Analysieren des PDF-Inhalts...",
  pdfHasNoPages: "PDF hat keine Seiten",
  pdfHasNoText: "PDF hat keinen Text",
  pdfHasNoTextOnFirstPage: "PDF hat keinen Text auf der ersten Seite",
  documentHasOnlyOnePage: "Das Dokument hat nur eine Seite - es könnten erforderliche Informationen fehlen",
  processingPageContent: "Verarbeiten des Seiteninhalts...",
  enhancingTextExtractionWithOcr: "Verbessern der Textextraktion mit OCR...",
  enhancingPage: "Seite verbessern",
  processingPage: "Verarbeiten der Seite",
  of: "von",
  textExtractionWithOcr: "Textextraktion mit OCR",
  textExtractionWithOcrFailed: "Textextraktion mit OCR auf Seite fehlgeschlagen",
  pdfBlankOrEmpty: "PDF scheint leer zu sein",
  errorDuringTextExtraction: "Fehler bei der Textextraktion",
  errorValidatingPdf: "Fehler bei der Validierung des PDFs",
  startingDocumentAnalysis: "Starte Dokumentenanalyse...",
  documentPassedValidation: "Dokument hat die Validierung bestanden",
  documentFailedValidation: "Dokument hat die Validierung nicht bestanden",
  downLoadFile: "Datei herunterladen",
  invalidValues: "Ungültige Werte",
  startingTextExtraction: "Starte Textextraktion...",
  close: "Schließen",
  confirmationTitle: "Bestätigung",
  confirmationMessage: "Sind Sie sicher, dass Sie die Validierung schließen möchten?",
  coverLetterPassedValidation: "hat die Validierung bestanden",
  validationCategories: {
    documentType: "Dokumenttyp",
    certificateNumber: "Zertifikatsnummer",
    dates: "Daten",
    software: "Software",
    organizations: "Organisationen",
    other: "Sonstiges",
  },
  requiredTextValidation: {
    title: "Erforderliche Textvalidierung:",
    notFound: "Nicht gefunden",
    found: "Gefunden",
  },
  warnings: {
    title: "Warnungen:",
    noWarnings: "Keine Warnungen",
    withWarning: "mit Warnung",
  },
  rescanPdf: {
    tooltipOCRExplain:
      "OCR (Optical Character Recognition) verbessert die Textextraktion, indem es Text in Bildern erkennt",
    useOcr: "OCR verwenden",
    rescan: "Neu scannen",
  },
};
